<template>
  <!-- Create / Edit -->
  <v-dialog v-model="dialog" width="600" persistent :fullscreen="fullscreen">
    <v-toolbar>
      <v-toolbar-title>{{ $route.meta.nameDrawer }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="closeDialog()"><v-icon>mdi-close</v-icon></v-btn>
    </v-toolbar>
    <v-card>
      <v-card>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation autocomplete="off">
            <!-- ========================================= -->
            <!--             Registration form             -->
            <!-- ========================================= -->
            <v-subheader class="overline pt-4">{{
              $t("registrationForm")
            }}</v-subheader>
            <div class="pa-4 px-6">
              <v-text-field
                :label="$t('fullNameLabel')"
                v-model="form.fullName"
                :rules="fullNameRules"
                required
                clearable
                outlined
                dense
                autofocus
              ></v-text-field>
            </div>
            <!-- ========================================= -->
            <!--                Routes                     -->
            <!-- ========================================= -->
            <v-subheader class="overline pt-4">{{
              $t("routeLabel")
            }}</v-subheader>
            <div class="pa-4 px-6">
              <v-autocomplete
                v-model="form.routes.select"
                :items="form.routes.items"
                :rules="selectRules"
                item-text="nome"
                item-value="id"
                :label="$t('selectRoutes')"
                outlined
                chips
                dense
                multiple
                required
              ></v-autocomplete>
            </div>

            <!-- ========================================= -->
            <!--                CredentialS                -->
            <!-- ========================================= -->
            <v-subheader class="overline pt-4">{{
              $t("accessCredential")
            }}</v-subheader>
            <div class="pa-4 px-6">
              <v-text-field
                :label="$t('labelLogin')"
                v-model="form.login"
                :rules="usernameRules"
                required
                clearable
                outlined
                dense
                autocapitalize="off"
              ></v-text-field>

              <template v-if="edit">
                <v-btn @click="editPassword = !editPassword" class="mb-3">
                  {{ $t("btnChangePassword") }}
                </v-btn>
              </template>
              <template v-if="editPassword || !edit">
                <v-text-field
                  :class="[
                    !form.password || show ? 'show-password' : 'hide-password',
                  ]"
                  :label="$t('passwordLabel')"
                  v-model="form.password"
                  :rules="passwordRules"
                  required
                  clearable
                  outlined
                  dense
                  :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="show = !show"
                  type="text"
                  :counter="8"
                  maxlength="8"
                  autocapitalize="off"
                ></v-text-field>
                <v-text-field
                  :class="[
                    !form.confirmPassword || show1
                      ? 'show-password'
                      : 'hide-password',
                  ]"
                  :label="$t('confirmPassword')"
                  v-model="form.confirmPassword"
                  :rules="confirmPasswordRules"
                  required
                  clearable
                  outlined
                  dense
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="show1 = !show1"
                  type="text"
                  :counter="8"
                  maxlength="8"
                  autocapitalize="off"
                ></v-text-field>
              </template>
            </div>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-alert
          class="ma-4"
          type="warning"
          v-for="item in handleError.items"
          :key="item"
          close-icon
        >
          {{ item }}
        </v-alert>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :loading="loading"
            v-on:click.prevent="updateCollector"
            type="submit"
            :disabled="!valid"
          >
            {{ $t("btnSave") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-card>
  </v-dialog>
</template>
<script>
import { validate } from "@/util/validate";
export default {
  name: "regional-manager-users-collector-update",
  data: () => ({
    // Utils
    valid: false,
    show: false,
    show1: false,
    loading: false,
    editPassword: false,
    // Form data:
    form: {
      fullName: "",
      routes: {
        select: [],
        items: [],
      },
      login: "",
      password: "",
      confirmPassword: "",
    },
    // Transforma type password em type text
    fieldTypes: {
      password: "text",
    },
    // Validate Forms:
    fullNameRules: [validate.required, validate.nameValid, validate.max],
    requiredRules: [validate.required],
    selectRules: [validate.selectRequired],
    usernameRules: [
      validate.required,
      validate.usernameMax,
      validate.usernameAz09,
      validate.max,
    ],
    passwordRules: [
      validate.required,
      validate.passRule,
      validate.passCaracter,
      validate.max,
    ],
    // Handle Error:
    handleError: {
      items: [],
    },
    // Edit
    edit: false,
    id_user: "",
    id_regional: "",
  }),
  async mounted() {
    let routesAvailable = this.$request.get(
      "regionalManager/collectors/routesAvailable"
    );
    // Request's Simultaneously
    let routes = await routesAvailable;

    if (routes != undefined) {
      this.form.routes.items = routes.dados;
    }

    // =================================================== //
    // IF - Edit
    // =================================================== //

    if (!this.$route.params.id) {
      return;
    }

    this.edit = true;

    this.id_user = this.$route.params.id;
    let userData = await this.$request.post(
      "/regionalManager/collectors/getCollector",
      { id_user: this.id_user }
    );

    // Handle Routes Selecteds Edit:
    const routesSelected = userData.routesCollectors;
    routesSelected.forEach((element) => {
      this.form.routes.items.push(element);
    });
    this.form.routes.select = routesSelected;

    const { nome, login, id_regional } = userData.dados;
    this.id_regional = id_regional;
    this.form.fullName = nome;
    this.form.login = login;
  },
  computed: {
    dialog() {
      return this.$store.state.showDialog;
    },
    fullscreen() {
      return this.$store.state.fullscreen;
    },
    //
    // Confirm Password Rules:
    confirmPasswordRules() {
      const rules = [];
      const req = "required";
      if (req) {
        const rule = (v) => !!v || this.$t("rulesPassMatch");
        rules.push(rule);
      }
      if (this.form.confirmPassword) {
        const rule = (v) =>
          (!!v && v) === this.form.password || this.$t("repeatThePassword");
        rules.push(rule);
      }
      return rules;
    },
  },
  watch: {
    dialog(val) {
      !val && this.$router.go(-1);
    },
  },
  methods: {
    //
    // updateCollector: Create or Edit Agent.
    async updateCollector() {
      if (!this.$refs.form.validate()) {
        return;
      }

      // Progress
      this.$store.commit("setFeedbackProgress", true);
      this.loading = true;

      // Body Request Verify Login
      const verifyLogin = {
        domain: this.$localStorage.getItem("user_data").db_name,
        login: this.form.login,
      };

      // Body Form
      const formUpdateCollectors = {
        nome: this.form.fullName,
        login: this.form.login,
        password: this.form.password,
      };

      // Handler routes to formUpdateCollectors
      const selected = this.form.routes.select;

      const routes = {};
      for (let i = 0; i < selected.length; i++) {
        routes[`routes[${i}]`] =
          selected[i].id == undefined ? selected[i] : selected[i].id;
      }

      Object.assign(formUpdateCollectors, routes);

      try {
        if (this.edit) {
          Object.assign(formUpdateCollectors, { id_collector: this.id_user });
        } else {
          // Verify Login:
          const verify = await this.$request.post(
            "main/fetchLogin",
            verifyLogin
          );
          if (verify.length == 0) {
            return;
          }
        }

        // Handle Endpoint
        const updateEndpoint = this.edit
          ? "regionalManager/collectors/editCollector"
          : "regionalManager/collectors/addCollector";

        const result = await this.$request.post(
          updateEndpoint,
          formUpdateCollectors
        );
        if (result.length == 0) {
          return;
        }

        this.$store.commit("setFeedbackSnack", {
          msg: result.messages,
          color: "success",
        });

        if (!this.edit) {
          this.$refs.form.reset();
        }

        this.$store.commit("showDialog", false);
        this.$store.commit("setRefresh", true);
      } catch (error) {
        // Multiple error handler:
        if (error.response.status == 406) {
          const items = [];
          var obj = error.response.data.messages;
          for (var [key, value] of Object.entries(obj)) {
            const item = `${key}: ${value}`;
            items.push(item);
          }
          this.handleError.items = items;
        }
      } finally {
        this.loading = false;
      }
    },

    // Close Dialog
    closeDialog() {
      this.$store.commit("showDialog", false);
    },
    // Tratando password
    // handleType() {
    //   this.fieldTypes.password = "password";
    // },
  },
};
</script>
